import { Skeleton, Stack, Table } from '@mantine/core';

interface TableSkeletonRowsProps {
  columns: number;
  rows?: number;
}

interface ContentSkeletonProps {
  height?: number;
  rows?: number;
}

const DEFAULT_ROWS = 5;

export function TableSkeletonRows({
  columns,
  rows = DEFAULT_ROWS,
}: TableSkeletonRowsProps) {
  return Array.from({ length: rows }).map((_, rowIndex) => (
    <Table.Tr key={rowIndex}>
      {Array.from({ length: columns }).map((__, columnIndex) => (
        <Table.Td key={columnIndex}>
          <Skeleton height={20} />
        </Table.Td>
      ))}
    </Table.Tr>
  ));
}

export function ContentSkeleton({
  height = 40,
  rows = DEFAULT_ROWS,
}: ContentSkeletonProps) {
  return (
    <Stack gap="sm" w="100%" aria-busy="true">
      {Array.from({ length: rows }).map((_, index) => (
        <Skeleton key={index} height={height} />
      ))}
    </Stack>
  );
}
